export default __webpack_public_path__ + "static/media/033-fridge.99f85315.svg";